export default {"src":"/_next/static/media/DPZ.07719df7.svg","height":18,"width":18};